(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PremDiscDialogController', PremDiscDialogController);

    PremDiscDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PremDisc', 'PremDiscGroup'];

    function PremDiscDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PremDisc, PremDiscGroup) {
        var vm = this;

        vm.premDisc = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.premdiscgroups = PremDiscGroup.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.premDisc.id !== null) {
                PremDisc.update(vm.premDisc, onSaveSuccess, onSaveError);
            } else {
                PremDisc.save(vm.premDisc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:premDiscUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdOn = false;
        vm.datePickerOpenStatus.modifiedOn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
